// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"6a41fbe7","1117":"abec6774","2853":"256bd059","2877":"8fcaacb0","6156":"d03fd043","6772":"2cfbd356","8157":"3d8fa41b","9536":"79ce7f88"}[chunkId] + ".chunk.css";
};